// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3LAkS","balanceDisclaimer":"posDashboard_balanceDisclaimer__2WotQ"};